import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useAuth } from "contexts/AuthContext";

export const useAllDeleteReferenceMeasurementsMutation = () => {
  const { authApi } = useAuth();
  const queryClient = useQueryClient();

  const result = useMutation({
    mutationFn: async (payload: { tourId: string }) => {
      const { data } = await authApi.delete(
        `/virtual-tour/${payload.tourId}/reference-measurements`
      );
      return data;
    },
    onSuccess: (_, { tourId }) => {
      queryClient.invalidateQueries({
        queryKey: ["virtual-tour-reference-measurements", tourId],
      });
    },
  });

  return result;
};
